export default theme => ({

  navLink: {
    textAlign: 'left'
  },

  navLinkActive: {
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },

  navLinkIcon: {
    marginRight: 0
  }

});



// WEBPACK FOOTER //
// ./src/styles/components/NavListItem.js